var getIsWindows = function getIsWindows() {
  return !!(navigator && navigator.userAgent && navigator.userAgent.indexOf('Win') > -1);
};

export { getIsWindows };
